"use client";

import { fetchExportDataAction } from "@/api/actions/bookmarkClipShare";
import { deleteManyBookmarkAction, updateBookmarkAction, createBookmarkAction } from "@/api/actions/bookmarks";
import { BookmarkV2Response } from "@/api/bookmarks";
import { useSnackAlert } from "../../useSnackAlert";
import { useState } from "react";
import { exportToCsv } from "../../helpers";

export enum BookmarkActionsEnum {
  NONE = "none",
  EDIT = "edit",
  DELETE = "delete",
  CREATE = "create",
}

export const useBookmarkActions = ({ selectedRows, onActionSuccess }: { selectedRows: BookmarkV2Response[], onActionSuccess: () => void }) => {

  const { showSnackbar } = useSnackAlert();

  const [actionSelected, setActionSelected] = useState<BookmarkActionsEnum>(BookmarkActionsEnum.NONE);
  const handleClick = (action: BookmarkActionsEnum) => {
    setActionSelected(action);
  };

  const handleDelete = async () => {
    try {
      await deleteManyBookmarkAction(selectedRows.map((row) => row.id));
      setActionSelected(BookmarkActionsEnum.NONE);
      showSnackbar("Folder deleted successfully", "success");
      onActionSuccess();
    } catch (_error) {
      console.error("Error deleting folder", _error);
      showSnackbar("Error deleting folder", "error");
    }
  };

  const handleEdit = async (title: string, isPrivate: boolean) => {
    try {
      await updateBookmarkAction(selectedRows[0].id, { title, visible: isPrivate });
      setActionSelected(BookmarkActionsEnum.NONE);
      showSnackbar("Folder updated successfully", "success");
      onActionSuccess();
    } catch (_error) {
      showSnackbar("Error updating folder", "error");
    }
  };

  const handleCreate = async (title: string, isPrivate: boolean) => {
    try {
      await createBookmarkAction({ title, visible: isPrivate });
      setActionSelected(BookmarkActionsEnum.NONE);
      showSnackbar("Folder created successfully", "success");
      onActionSuccess();
    } catch (_error) {
      showSnackbar("Error creating folder", "error");
    }
  };

  const exportBookmarks = async () => {
    try {
      const bookmarkDetails = await fetchExportDataAction(selectedRows[0].id);
      exportToCsv(bookmarkDetails);
    } catch (_error) {
      showSnackbar("Error exporting bookmarks", "error");
    }
  };

  return { actionSelected, handleClick, handleDelete, handleEdit, handleCreate, exportBookmarks, setActionSelected };
};